import { useEffect, useState } from 'react';
import {
  fetchFeatureFlags,
  getCachedFeatureFlags,
  isFeatureEnabled,
  FeatureFlag,
} from 'src/config/featureFlags';

/**
 * Returns true when the Orion UI feature flag is enabled.
 *
 * To avoid a flash-of-old-UI on reload, the initial state is seeded
 * synchronously from the persisted localStorage cache (set by the previous
 * successful `fetchFeatureFlags()` call). The async fetch still runs and
 * overrides the cached value once it resolves, so newly flipped flags
 * propagate within one network round-trip.
 */
export const useOrionUI = (): boolean => {
  const [enabled, setEnabled] = useState<boolean>(() => {
    const cached = getCachedFeatureFlags();
    return cached ? isFeatureEnabled(cached, FeatureFlag.ORION_UI) : false;
  });

  useEffect(() => {
    fetchFeatureFlags().then((flags) => {
      const next = isFeatureEnabled(flags, FeatureFlag.ORION_UI);
      // Only re-render when the freshly fetched value differs from what we
      // already painted from cache.
      setEnabled((prev) => (prev === next ? prev : next));
    });
  }, []);

  return enabled;
};
